export default __webpack_public_path__ + "fd874d0e51c2faeed8bf2ad95c8701ef.svg";